<template>
  <div :class="$style.card">
    <GoogleReviewCard v-if="item.type === 'google'" :item="item" />
    <InstagramCard v-if="item.type === 'instagram'" :item="item" />
    <TrustpilotCard v-if="item.type === 'trustpilot'" :item="item" />
    <TwitterCard v-if="item.type === 'twitter'" :item="item" />
    <YoutubeCard v-if="item.type === 'youtube'" :item="item" />
  </div>
</template>

<script>
import GoogleReviewCard from './GoogleReviewCard.vue'
import InstagramCard from './InstagramCard.vue'
import TrustpilotCard from './TrustpilotCard.vue'
import TwitterCard from './TwitterCard.vue'
import YoutubeCard from './YoutubeCard.vue'

export default {
  name: 'Card',
  components: {
    GoogleReviewCard,
    InstagramCard,
    TrustpilotCard,
    TwitterCard,
    YoutubeCard,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" module>
.card {
  width: 400px;
  border: 1px solid #eae9e3;
  border-radius: 8px;

  overflow-wrap: anywhere;

  @include below(large) {
    width: 350px;
  }
  @include below(small) {
    width: 320px;
  }
  &:hover {
    box-shadow: 2px 2px 8px $gray-200;
    transform: translate(-2px, -2px);
  }
  cursor: pointer;

  transition: all 0.3s ease;
}
</style>
